const globalSettings = {
    theme: 'default',
    dataType: 'pull',
    autoSave: true,
    autoSaveInterval: 5,
    notificationSound: 'off',
    notificationType: 'screenOnly',
    region: 'US',
    showVideo: false,
    functions: '',
    userGuide:
        'https://morningstardirect.morningstar.com/clientcomm/MarketMonitoring.pdf'
};

export default globalSettings;
